import urls from "./urls"
import globalVariables from "./globalVariables"
import { post } from './serverRequests'

export async function getFreshToken() {
    let refresh_token = localStorage.getItem(globalVariables.AUTH_TOKEN)
    // console.log("refresh token",refresh_token)
    if (refresh_token === null) {
        return false
    }
    return true
}


export async function signOut() {
    let refresh_token = localStorage.getItem(globalVariables.AUTH_TOKEN)
    let headers = {
        "Authorization": `Bearer ${refresh_token}`,
        'content-type': 'application/json'
    }
    let post_data = {}
    let data = await post(urls.LOGOUT, post_data, headers);
    // console.log("logout")
    if (data !== false) {
        
            localStorage.clear();
          
            window.location.replace('/');
            setTimeout(() => {
                alert(data['detail'])
            }, 1000);
    
    }
    else {
        alert('Something went wrong. Please try again !!!')
    }
}